import Component from './SampleType';
import createRenderer from './SampleType.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/SampleType/index.js